import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitleSearchById } from "../api/titleService";
import { useDetailEntity } from "./useDetailEntity";
import { TITLE_ENFORCEMENT_DETAIL_KEY } from "../utils/agendaQueries";
import { parseUnitKey, unitKey } from "../utils/monographUnit";
export var useTitleEnforcementActions = function () {
    var kyInstance = useOkapiKy();
    var _a = useDetailEntity(TITLE_ENFORCEMENT_DETAIL_KEY, function (key) {
        var _a = parseUnitKey(key), titleId = _a.titleId, issueId = _a.issueId;
        return fetchTitleSearchById(kyInstance, titleId, issueId);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedTitle: selectedItem,
        handleSelectTitle: function (title) {
            return handleRowClick(unitKey(title.id, title.periodicalIssueId));
        },
        handleCloseSelectedTitle: handleCloseDetail,
    };
};
